export default "__VITE_ASSET__B7S2ZDpP__"